import { Business } from '@40seas/entities/businesses';
import { Omit } from '@40seas/entities/common';

export class Buyer extends Omit(Business, ['types'], ['types']) {}
